import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#09090b]/90 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("hero")}
          className="flex items-center gap-3 shrink-0"
        >
          <img src="/mpm/logo.png" alt="Mad Props Marine" className="h-11 w-auto" />
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium tracking-wide text-white/70 hover:text-white transition-colors duration-300 relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#e85d04] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-call-button"
            href={`tel:${CONTACT.phoneRaw}`}
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#e85d04] hover:bg-[#dc2f02] text-white text-sm font-semibold px-5 py-2.5 transition-colors duration-300"
          >
            <Phone size={16} />
            {CONTACT.phone}
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#09090b]/98 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4"
        >
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-lg font-display font-semibold text-white/80 hover:text-[#e85d04] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#e85d04] text-white font-semibold px-5 py-3"
          >
            <Phone size={16} /> {CONTACT.phone}
          </a>
        </div>
      )}
    </header>
  );
};
